/*
This file is for handle Brand Logo and Icon.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import ViewProperties from './../ViewProperties';
import Element from './../Element';
import View from './../View';
import DefaultSkin from '../assets/css/defaultCss';

const Branding = (spec) => {
    const view = View({});
    const that = {};
    let isDefaultSkin = false;
    const brand = ViewProperties().brand.default;
    if (spec) {
        if (Element.checkParam(spec.clickthru)) { brand.url = spec.clickthru; }
        if (spec.target && spec.target == 'current') { brand.target = '_self'; }
        if (Element.checkParam(spec.logo)) { brand.logo = spec.logo; }
        if (Element.checkParam(spec.title)) { brand.title = spec.title; }
        if (spec.display !== undefined) { brand.display = spec.display; }
        isDefaultSkin = spec.skin === 'default';
    }
    that.link = Element({
        name: 'a', title: brand.title, href: brand.url, target: brand.target,
    });
    if (isDefaultSkin) { that.brandIcon = Element({ name: 'img', src: brand.logo, style: DefaultSkin.brand_logo }); } else { that.brandIcon = Element({ name: 'img', class: `${spec.skin}_brand_logo`, src: brand.logo }); }
    that.link.appendChild(that.brandIcon);
    if (!Element.checkParam(brand.display)) {
        that.link.style.display = 'none';
    }
    return that.link;
};

export default Branding;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/Branding.js
// module id = 183
// module chunks = 0